export default "__VITE_PUBLIC_ASSET__c04cf254__"